module.exports = __webpack_public_path__ + "img/scoreBoardCompressed.769ba475.gif";